import React, { useState, useEffect } from 'react';
import { View, StyleSheet, FlatList, SafeAreaView, Text, Image, TouchableOpacity, ScrollView } from 'react-native';
import { Searchbar, Chip, useTheme, Card, ActivityIndicator, Snackbar, Button } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { getAllCategories, getFeaturedItems } from '../../api/menuAPI';
import LoadingIndicator from '../../components/LoadingIndicator';
import ErrorMessage from '../../components/ErrorMessage';
import { useAuth } from '../../context/AuthContext';

const MenuScreen = ({ navigation, route }) => {
  const theme = useTheme();
  const { isAuthenticated } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [categories, setCategories] = useState([]);
  const [popularItems, setPopularItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  
  // Giriş yapılmadan erişilip erişilmediğini kontrol et
  const isPreview = !isAuthenticated;
  
  // Kategorileri ve öne çıkan öğeleri yükle
  useEffect(() => {
    loadMenuData();
  }, []);
  
  const loadMenuData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Kategorileri yükle
      const categoriesResponse = await getAllCategories();
      if (categoriesResponse.success) {
        setCategories(categoriesResponse.categories || categoriesResponse.data || []);
      } else {
        console.error('Kategoriler yüklenemedi:', categoriesResponse.message);
        setCategories([]);
      }
      
      // Öne çıkan öğeleri yükle
      try {
        const featuredResponse = await getFeaturedItems();
        if (featuredResponse.success) {
          setPopularItems(featuredResponse.featuredItems || featuredResponse.data || []);
        }
      } catch (err) {
        console.error('Öne çıkan öğeler yüklenirken hata:', err);
      }
      
    } catch (err) {
      console.error('Menü yüklenirken hata:', err);
      setError('Menü verileri yüklenirken bir hata oluştu. Lütfen tekrar deneyin.');
      setSnackbarMessage('Menü verileri yüklenirken bir hata oluştu');
      setSnackbarVisible(true);
    } finally {
      setLoading(false);
    }
  };
  
  const onSearch = (query) => {
    setSearchQuery(query);
  };
  
  const renderCategoryItem = ({ item }) => (
    <TouchableOpacity 
      style={styles.categoryItem}
      onPress={() => navigation.navigate('MenuCategory', { 
        categoryId: item.id,
        categoryName: item.name 
      })}
    >
      <View style={styles.categoryCard}>
        <View style={styles.categoryIcon}>
          <MaterialCommunityIcons 
            name={getCategoryIcon(item.name)} 
            size={36} 
            color="#fff" 
          />
        </View>
        <Text style={styles.categoryName}>{item.name}</Text>
      </View>
    </TouchableOpacity>
  );
  
  // Kategori adına göre ilgili icon'u belirle
  const getCategoryIcon = (categoryName) => {
    const categoryIcons = {
      'Meşrubatlar': 'cup',
      'Tatlılar': 'cake-variant',
      'Atıştırmalıklar': 'food-croissant',
      'Yemekler': 'hamburger',
      'Kahveler': 'coffee',
      'Çaylar': 'kettle-steam',
      // Varsayılan değerler
      'default': 'food'
    };
    
    return categoryIcons[categoryName] || categoryIcons.default;
  };
  
  const renderPopularItem = (item) => (
    <TouchableOpacity 
      key={item.id}
      style={styles.popularItem}
      onPress={() => navigation.navigate('MenuItem', { 
        itemId: item.id,
        itemName: item.name
      })}
    >
      <Card style={styles.popularCard}>
        <Card.Cover source={{ uri: item.image_url || 'https://picsum.photos/700' }} style={styles.popularImage} />
        <Card.Content style={styles.popularContent}>
          <Text style={styles.popularItemName}>{item.name}</Text>
          <Text style={styles.popularItemPrice}>{item.price} ₺</Text>
        </Card.Content>
      </Card>
    </TouchableOpacity>
  );
  
  if (loading) {
    return <LoadingIndicator message="Menü yükleniyor..." />;
  }
  
  if (error) {
    return <ErrorMessage message={error} onRetry={loadMenuData} />;
  }
  
  return (
    <SafeAreaView style={styles.container}>
      
      {/* <View style={styles.searchContainer}>
        <Searchbar
          placeholder="Menüde ara..."
          onChangeText={onSearch}
          value={searchQuery}
          style={styles.searchBar}
        />
      </View> */}
      
      
      <ScrollView>
        
        {/*<Text style={styles.sectionTitle}>Kategorilessr</Text>*/}
        <FlatList
          data={categories}
          renderItem={renderCategoryItem}
          keyExtractor={(item) => item.id?.toString() || Math.random().toString()}
          numColumns={2}
          contentContainerStyle={styles.listContent}
          scrollEnabled={false}
        />
      
        
        
       
      </ScrollView>
      
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        style={{backgroundColor: 'rgb(125, 76, 236)'}}
        theme={{colors: {surface: '#fff'}}}
        action={{
          label: 'Tamam',
          onPress: () => setSnackbarVisible(false),
          color: '#fff'
        }}
      >
        {snackbarMessage}
      </Snackbar>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  searchContainer: {
    padding: 16,
    paddingBottom: 8,
  },
  searchBar: {
    borderRadius: 8,
    elevation: 2,
    backgroundColor: 'white',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginLeft: 16,
    marginTop: 16,
    marginBottom: 8,
    color: 'rgb(125, 76, 236)',
  },
  listContent: {
    padding: 8,
  },
  categoryItem: {
    flex: 1,
    padding: 8,
  },
  categoryCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    minHeight: 120,
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  categoryIcon: {
    backgroundColor: 'rgb(125, 76, 236)',
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
  },
  categoryName: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
    color: 'rgb(90, 50, 180)',
  },
  categoryCount: {
    fontSize: 12,
    color: 'rgb(90, 50, 180)',
    marginTop: 4,
  },
  popularItemsContainer: {
    padding: 8,
    paddingLeft: 16,
  },
  popularItem: {
    width: 160,
    marginRight: 12,
  },
  popularCard: {
    borderRadius: 12,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  popularImage: {
    height: 100,
  },
  popularContent: {
    padding: 8,
  },
  popularItemName: {
    fontSize: 14,
    fontWeight: '600',
    color: 'rgb(125, 76, 236)',
  },
  popularItemPrice: {
    fontSize: 12,
    color: 'rgb(90, 50, 180)',
    marginTop: 2,
  },
  loginPrompt: {
    margin: 24,
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    alignItems: 'center',
    elevation: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  loginPromptText: {
    fontSize: 16,
    marginBottom: 16,
    color: 'rgb(90, 50, 180)',
    textAlign: 'center',
  },
  loginButton: {
    width: '80%',
    backgroundColor: 'rgb(125, 76, 236)',
  }
});

export default MenuScreen;
